// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@conklin/XDL/Utilities";
import { myListsViewStyles } from "@insite/content-library/Widgets/MyLists/MyListsView";
import { css } from "styled-components";

myListsViewStyles.select = {
    sizeVariant: "small",
    labelProps: {
        size: 14,
        lineHeight: "22px",
        css: css`
            padding: 7px 8px 0 0;
            ${xScreen("lte", "sm")} {
                min-width: 62px;
                &&&& {
                    text-align: left;
                }
            }
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            width: 162px;
            ${xScreen("lte", "md")} {
                width: 100%;
            }
        `,
    },
};
